import customAxios from '@/utils/customAxios.js';
import apiDomain from '@/config/api.js';
import externalComponent from '@/utils/external-component.js';
import eventBus from "@/utils/eventBus";

// Components
const Toolbar = () => externalComponent('toolbar');
const Table = () => externalComponent('table');
const Modal = () => externalComponent('modal');
const Pagination = () => externalComponent('pagination');
import ModalContent from '@/components/Reservations/Modal/Modal.vue';

export default {
  name: 'reservation',

  components: {
    Toolbar,
    Table,
    Modal,
    ModalContent,
    Pagination
  },

  data() {
    return {
      toolbar: {
        title: 'Listado de Reservas',
        mainAction: {
          name: 'Agregar Reserva',
          emit: 'add-item'
        },
        order: {
          name: 'Status',
          options: [
            { name: 'Todas', value: 'all' },
            { name: 'En espera', value: 'En Espera' },
            { name: 'Sin disponibilidad', value: 'Sin Disponibilidad' },
            { name: 'Enviada', value: 'Enviada' },
            { name: 'Confirmada', value: 'Confirmada' },
            { name: 'Vencida', value: 'Vencida' },
            { name: 'Cancelada', value: 'Cancelada' },
            { name: 'Checked out', value: 'Checked Out' }
          ]
        },
        search: {
          name: 'Buscar por',
          placeholder: '# de reserva'
        },
      },
      columns: [
        {
          name: '#'
        },
        {
          name: 'Fecha'
        },
        {
          name: 'Propiedad'
        },
        {
          name: 'Creador'
        },
        {
          name: 'Status',
          status: true
        }
      ],
      rows: [],
      modal: {
        'add': {
          title: 'Agregar Reserva',
          description: '',
          action: 'Agregar'
        },
        'edit': {
          title: 'Editar Reserva',
          description: '',
          action: 'Actualizar'
        }
      },
      totalItems: 0,
      itemsData: {
        filters: {},
        page: 1,
        itemsPerPage: 6,
        search: ''
      },
      pagination: {
        currentPage: 1,
        totalPages: 1
      },
      statusSelected: 'all',
      modalVisible: false,
      modalAction: '',
      selectedId: null,
    }
  },

  methods: {
    getItems: async function () {
      let items = null;

      if (this.statusSelected != 'all') {
        this.itemsData.filters.status = this.statusSelected;
      } else {
        delete this.itemsData.filters.status;
      }

      await customAxios
        .post(apiDomain + '/panel/reservation/filter', this.itemsData)
        .then(resp => items = resp)
        .catch(err => items = false);

      if (!items) {
        this.$toast.error('Error en la consulta');
      } else if (items.status == 204) {
        this.rows = [];
        this.totalItems = 0;
        this.pagination.totalPages = 1;
      } else {
        this.rows = items.data.items;
        this.pagination.totalPages = items.data.totalPages;
        this.totalItems = items.data.totalItems;
      }
    },

    addItem: function () {
      this.modalAction = 'add';
      this.selectedId = null;
      this.modalVisible = true;
    },

    editItem: function (id) {
      this.modalAction = 'edit';
      this.selectedId = id;
      this.modalVisible = true;
    },

    filterChanged: function () {
      this.itemsData.page = 1;
      this.getItems();
    },

    changePage: function (val) {
      this.itemsData.page = val;
      this.getItems();
    },

    orderToolbar: function (val) {
      this.statusSelected = val;
      this.filterChanged();
    },

    searchToolbar: function (val) {
      this.itemsData.search = val;
      this.filterChanged();
    },

    singleDelete: function (id) {
      this.deleteConfirmation([id]);
    },

    deleteConfirmation: function (ids) {
      let msg = "¿Estás seguro de eliminar ";
      msg += (ids.length > 1) ? "estos elementos?" : "este elemento?";

      this.$confirm({
        message: msg,
        button: {
          no: 'No',
          yes: 'Sí'
        },
        callback: confirm => {
          if (confirm) {
            this.deleteItems(ids);
          }
        }
      })
    },

    deleteItems: async function (ids) {
      let response = null;

      this.toggleLoader(true);

      await customAxios
        .post(apiDomain + '/panel/reservation/delete', { items: ids })
        .then(resp => response = resp)
        .catch(err => response = false);

      this.toggleLoader(false);

      if (!response) {
        this.$toast.error('Error eliminando item');
      } else {
        if (response.status != 200) {
          this.$toast.error('Error eliminando item');
        } else {
          this.$toast.success('Item/s eliminado/s con éxito');
          this.getItems();
        }
      }
    },

    toggleModal: function (status) {
      this.modalVisible = status;

      if (!status) {
        this.getItems();

        if (this.modalAction == 'edit') {
          this.$router.push({ path: '/reservaciones' });
        }
      }
    },

    verifyUrlParams: function () {
      const id = this.$route.params.id || null;

      if (id) {
        this.selectedId = id;
        this.modalAction = 'edit';
        this.modalVisible = true;
      }
    },

    changeToUnavailable: async function (id) {
      let response;

      await customAxios
        .put(apiDomain + '/panel/reservation/status/unavailable/' + id)
        .then(resp => response = resp)
        .catch(err => console.log(err));

      return response;
    },

    changeToSended: async function (id) {
      let response;

      await customAxios
        .put(apiDomain + '/panel/reservation/status/sended/' + id)
        .then(resp => response = resp)
        .catch(err => console.log(err));

      return response;
    },

    changeToCancelled: async function (id) {
      let response;

      await customAxios
        .put(apiDomain + '/panel/reservation/status/cancelled/' + id)
        .then(resp => response = resp)
        .catch(err => console.log(err));

      return response;
    },

    updateStatus: async function (id, value) {
      let response;

      switch (value) {
        case 'unavailable':
          response = await this.changeToUnavailable(id);
          break;
        case 'sended':
          response = await this.changeToSended(id);
          break;
        case 'cancelled':
          response = await this.changeToCancelled(id);
          break;
      }

      if (typeof response !== 'undefined' && response.status == 200) {
        this.getItems();

        this.$toast.success('Reserva actualizada con éxito');
      } else {
        this.$toast.error('Error al actualizar la reserva');
      }
    }
  },

  computed: {
    currentPage() {
      return this.pagination.currentPage;
    }
  },

  watch: {
    currentPage(val) {
      this.changePage(val);
    },

    $route() {
      this.verifyUrlParams();
    }
  },

  mounted() {
    this.verifyUrlParams();
    this.getItems();
  }
}
